/**
 *  Panel mutations module file
**/
import { MUTATIONS } from './constants'

export const mutations = {
  [MUTATIONS.SAVE_DEVICE_WIDTH]: (state, payload) => {
    state.deviceWidth = payload
  },
  [MUTATIONS.SAVE_IS_MOBILE]: (state, payload) => {
    state.isMobile = payload
  },
  [MUTATIONS.SAVE_CONFIG]: (state, payload) => {
    // Only save original steps order if it hasn't been set yet
    if (!state.originalStepsOrder && payload.route && payload.route.steps &&
        payload.route.steps.every(step => typeof step === 'string')) {
      state.originalStepsOrder = [...payload.route.steps]
      // Initialize the route with the steps from the config
      if (!state.route) {
        state.route = {
          steps: state.originalStepsOrder.map((id, index) => ({
            properties: { id },
            isOrigin: index === 0,
            isDestination: index === state.originalStepsOrder.length - 1
          })),
          duration: 0,
          distance: 0,
          z: 5
        }
      }
    }
    state.config = payload
  },
  [MUTATIONS.SET_COORDINATES]: (state, { coordinates, zoom }) => {
    state.coordinates = coordinates
    state.zoom = zoom
  },
  [MUTATIONS.BLOCK_BBOX]: (state, payload) => {
    state.blockBbox = payload
  },
  [MUTATIONS.SAVE_BBOX]: (state, payload) => {
    state.bbox = payload
  },
  [MUTATIONS.SAVE_ACCESS_TOKEN]: (state, payload) => {
    state.accessToken = payload
  },
  [MUTATIONS.SAVE_AIRPORT]: (state, payload) => {
    state.airport = {
      bbox: payload.bbox,
      iata_code: payload.iata_code,
      icao_code: payload.icao_code,
      name: payload.name,
      has_graph: payload.has_graph,
      pois_version_date: payload.pois_version_date,
      access_controls_has_wait_info: payload.access_controls_has_wait_info
    }

    state.buildings = payload.buildings
  },
  [MUTATIONS.SAVE_CARTOGRAPHY_TILES]: (state, payload) => {
    state.cartografyTiles = payload
  },
  [MUTATIONS.SAVE_POIS_CATALOG]: (state, payload) => {
    state.poisCatalog = payload
  },
  [MUTATIONS.SAVE_POIS_LIST]: (state, payload) => {
    state.poisList = payload
  },
  [MUTATIONS.SAVE_TRANSITION_POIS_LIST]: (state, payload) => {
    state.transitionPoisList = payload
  },
  [MUTATIONS.SAVE_UNCATEGORIZED_POIS_LIST]: (state, payload) => {
    state.uncategorizedPoisList = payload
  },
  [MUTATIONS.SAVE_POI]: (state, { poi, pointGrouped }) => {
    const callbackGrouped = (state.poi && poi.properties.id === state.poi.properties.id) ? state.pointGrouped : []

    state.poi = poi
    state.pointGrouped = pointGrouped || callbackGrouped
  },
  [MUTATIONS.CLEAR_POI]: (state) => {
    state.poi = undefined
    state.pointGrouped = []
  },
  [MUTATIONS.SAVE_FLOOR]: (state, payload = {}) => {
    state.floor = payload.floor
    state.building = payload.building
  },
  [MUTATIONS.SAVE_ACTIVE_FILTERS]: (state, payload = {}) => {
    state.activeFilters = payload
  },
  [MUTATIONS.SAVE_LAYER]: (state, layerConfig) => {
    state.layerTree.push(layerConfig)
  },
  [MUTATIONS.SAVE_ROUTE]: (state, payload) => {
    // Only reorder steps if we have original order and this is the first load
    if (state.originalStepsOrder && payload.steps && payload.steps.length > 0 &&
        !state.routeInitialized) {
      const hasMatchingSteps = payload.steps.every(s => s.properties &&
        state.originalStepsOrder.includes(s.properties.id))

      if (hasMatchingSteps) {
        const stepsMap = payload.steps.reduce((map, step) => {
          map[step.properties.id] = step
          return map
        }, {})
        payload.steps = state.originalStepsOrder.map((id, index) => ({
          ...stepsMap[id],
          isOrigin: index === 0,
          isDestination: index === state.originalStepsOrder.length - 1
        }))
        // Mark that route has been initialized
        state.routeInitialized = true
      }
    }
    state.route = {
      ...state.route,
      ...payload
    }
  },
  [MUTATIONS.SAVE_DEFAULT_LEVEL_BUILDING]: (state, payload = {}) => {
    state.route.defaultLevelBuilding = {
      ...payload,
      ...state.route.defaultLevelBuilding
    }
  },
  [MUTATIONS.SAVE_DESTINATION_NAME_ROUTE]: (state, payload) => {
    state.route.destinationName = payload
  },
  [MUTATIONS.SAVE_ROUTE_MODE]: (state, payload) => {
    state.routeMode = payload
  },
  [MUTATIONS.SAVE_VIEW]: (state, payload) => {
    state.view = payload
  },
  [MUTATIONS.REMOVE_LAYER]: (state, id) => {
    state.layerTree = state.layerTree.filter(x => x.id !== id)
  },
  [MUTATIONS.SAVE_PMR_CONFIG_VISIBILITY]: (state, visible) => {
    state.show_pmr_config = visible
  },
  [MUTATIONS.SAVE_PMR_PROFILE]: (state, profile) => {
    state.pmr_profile = profile
  },
  [MUTATIONS.SAVE_FEEDBACK]: (state, payload) => {
    state.feedback = payload
  },
  [MUTATIONS.SET_ROUTE_COUNT]: (state, payload) => {
    state.routeCount = payload
  },
  [MUTATIONS.SAVE_HOME_POSITION]: (state, payload) => {
    state.homePosition = payload
  },
  [MUTATIONS.SAVE_FILTERING]: (state, payload) => {
    state.filtering = payload
  }
}
